import { MaterialCommunityIcons } from "@expo/vector-icons";
import { useState } from "react";
import { Pressable, StyleSheet, View } from "react-native";
import { useCustomTheme } from "@luna-restaurant/ui";
import { MenuLabel } from "./MenuLabel";
export const MenuItem = ({ item, onToggle }) => {
    const { colors, fonts } = useCustomTheme();
    const [isHovered, setIsHovered] = useState(false);
    const onPress = (id) => {
        onToggle?.(id);
    };
    return (<Pressable style={[
            styles.container,
            {
                backgroundColor: item.isSelected || !onToggle
                    ? colors.successLighter
                    : isHovered
                        ? colors.sectionBackground
                        : colors.background,
            },
        ]} onPress={() => onPress(item.id)} onHoverIn={() => setIsHovered(true)} onHoverOut={() => setIsHovered(false)}>
      <View style={styles.firstRow}>
        {onToggle ? (<MaterialCommunityIcons name={item.isSelected ? "checkbox-marked" : "checkbox-blank-outline"} size={24} color={colors.border} style={isHovered
                ? [
                    styles.highlightedCheckbox,
                    {
                        outlineColor: colors.successLighter,
                    },
                ]
                : null}/>) : (<View />)}
        <MenuLabel label={item.label}/>
      </View>

      <View style={styles.secondRow}>
        <div style={{ ...styles.menuText, color: colors.text, ...fonts.regular }} dangerouslySetInnerHTML={{
            __html: item.title,
        }}/>
      </View>
    </Pressable>);
};
const styles = StyleSheet.create({
    container: {
        borderRadius: 4,
        padding: 8,
        paddingBottom: 12,
    },
    firstRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        height: 24,
        marginBottom: 10,
    },
    secondRow: {
        flexDirection: "row",
        alignItems: "flex-start",
    },
    menuText: {
        fontSize: 15,
        userSelect: "none", // so that text is not accidentally marked, when the user toggles the checkbox
    },
    highlightedCheckbox: {
        borderRadius: 4,
        outlineOffset: -3,
        outlineWidth: 3,
        outlineStyle: "solid",
    },
});
//# sourceMappingURL=MenuItem.web.js.map